// extracted by mini-css-extract-plugin
module.exports = {"loadingSkeleton":"loadingSkeleton_1OaI1"};